import { useEffect, useState } from "react";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Plus, Edit2, Trash2 } from "lucide-react";
import { toast } from "sonner";

const EMPTY = { title: "", description: "", event_date: "", venue: "", category: "आयोजन" };

export default function EventsPage() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [editId, setEditId] = useState(null);

  const load = () => api.get("/events").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const submit = async () => {
    try {
      if (editId) await api.put(`/events/${editId}`, form); else await api.post("/events", form);
      toast.success("सहेज दिया"); setOpen(false); setForm(EMPTY); setEditId(null); load();
    } catch(err) { toast.error(formatError(err)); }
  };
  const del = async (id) => { if (!window.confirm("हटाएँ?")) return; await api.delete(`/events/${id}`); load(); };

  return (
    <div data-testid="events-page">
      <div className="flex items-center justify-between mb-6">
        <div><h1 className="text-2xl font-bold">स्थानीय आयोजन</h1><p className="text-sm text-slate-500 mt-1">{items.length} आयोजन</p></div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button className="bg-[#DC2626] hover:bg-red-700" onClick={() => { setForm(EMPTY); setEditId(null); }} data-testid="add-event-btn"><Plus className="w-4 h-4 mr-1.5"/>नया आयोजन</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>आयोजन</DialogTitle><DialogDescription>मेला, कार्यक्रम, बैठक की जानकारी जोड़ें</DialogDescription></DialogHeader>
            <div className="space-y-3">
              <div><Label>शीर्षक</Label><Input value={form.title} onChange={(e) => setForm({...form, title: e.target.value})} data-testid="event-title"/></div>
              <div className="grid grid-cols-2 gap-3">
                <div><Label>दिनांक</Label><Input type="date" value={form.event_date?.slice(0,10) || ""} onChange={(e) => setForm({...form, event_date: e.target.value})} data-testid="event-date"/></div>
                <div><Label>श्रेणी</Label><Input value={form.category} onChange={(e) => setForm({...form, category: e.target.value})} placeholder="मेला / बैठक / धार्मिक"/></div>
              </div>
              <div><Label>स्थल</Label><Input value={form.venue} onChange={(e) => setForm({...form, venue: e.target.value})} placeholder="सूरजपुर स्टेडियम" data-testid="event-venue"/></div>
              <div><Label>विवरण</Label><Textarea rows={3} value={form.description} onChange={(e) => setForm({...form, description: e.target.value})}/></div>
            </div>
            <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>रद्द</Button><Button onClick={submit} className="bg-[#DC2626] hover:bg-red-700" data-testid="save-event">सहेजें</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
      <div className="bg-white border border-slate-200 rounded-lg shadow-sm overflow-hidden">
        <Table>
          <TableHeader><TableRow><TableHead>दिनांक</TableHead><TableHead>शीर्षक</TableHead><TableHead>स्थल</TableHead><TableHead>श्रेणी</TableHead><TableHead className="text-right">कार्य</TableHead></TableRow></TableHeader>
          <TableBody>
            {items.map((e) => (
              <TableRow key={e.id}>
                <TableCell className="font-mono text-xs">{new Date(e.event_date).toLocaleDateString("hi-IN")}</TableCell>
                <TableCell className="font-medium">{e.title}</TableCell>
                <TableCell className="text-xs">{e.venue}</TableCell>
                <TableCell className="text-xs">{e.category}</TableCell>
                <TableCell className="text-right">
                  <Button variant="ghost" size="sm" onClick={() => { setForm({title:e.title,description:e.description,event_date:e.event_date?.slice(0,10) || "",venue:e.venue,category:e.category}); setEditId(e.id); setOpen(true); }}><Edit2 className="w-4 h-4"/></Button>
                  <Button variant="ghost" size="sm" onClick={() => del(e.id)}><Trash2 className="w-4 h-4 text-red-500"/></Button>
                </TableCell>
              </TableRow>
            ))}
            {items.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-slate-500 py-8">कोई आयोजन नहीं</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
